export default {
    bgColor: 0x8bea39,
    primaryKey: "BGElmnts_Cn1",
    secondaryKey: "BGElmnts_Cn2",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.y = -100;
        image.x = data.x;
        let deltaY = 1 - (data.y/bg.scene.size.height);

        bg.scene.addTween(image, 1000, {y: data.y, angle: data.angle, delay: 500 * deltaY}, "Bounce");
    },
    animateOut: (image, bg)=>{
        let deltaY = 1 - (image.y/bg.scene.size.height);
        bg.scene.addTween(image, 1000, {y: 1200, delay: 500 * deltaY, angle: 0}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_Cn1",
            x: 801.9322188727506, y: 367.75055679287306,
            angle: 13,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 699.8694228033773, y: 684.8975501113586,
            angle: 13,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 949.0197444831592, y: 627.7416481069042,
            angle: 22,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 902.9950149421238, y: 51.61692650334076,
            angle: 13,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 119.46597241253312, y: 12.11804008908686,
            angle: 17,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 1000.347335865012, y: 179.03340757238308,
            angle: -8,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 208.1078181889363, y: 133.4164810690423,
            angle: -3,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 1050.320661890407, y: 309.8708240534521,
            angle: 21,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 761.3017656500803, y: 564.6258351893096,
            angle: 61,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 19.547938769917394, y: 327.43652561247217,
            angle: 23,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 862.3512247321511, y: 246.74164810690425,
            angle: 62,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 321.8410784428872, y: 305.0556792873051,
            angle: -9,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 897.2845397956388, y: 495.7594654788419,
            angle: -7,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 106.20312153362305, y: 450.1425389755011,
            angle: -3,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 519.2695324224511, y: 633.3073496659243,
            angle: -18,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 220.66019392136138, y: 624.6102449888641,
            angle: -10,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 724.67131242741, y: -0.447661469933184,
            angle: -18,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 309.183951245612, y: 741.7639198218263,
            angle: -24,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 621.7666157720968, y: 315.7260579064588,
            angle: -18,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 427.4962612065928, y: -12.579064587973274,
            angle: -8,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 413.65436062065277, y: 424.77505567928733,
            angle: -30,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 516.2828694097535, y: 107.04899777282851,
            angle: -30,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 1037.636860718527, y: 746.7772828507796,
            angle: -4,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: 2.1003145023424565, y: 765.4743875278397,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn1",
            x: -33.58348666953764, y: 192.5857461024499,
            angle: -2,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 781.1436662360204, y: 120.15367483296214,
            angle: 9,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 377.01057041068003, y: 197.1380846325167,
            angle: 9,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 678.0675331793447, y: 439.3140311804009,
            angle: 9,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 962.1511699226143, y: 394.84187082405344,
            angle: 41,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 860.6540865729685, y: 711.6993318485523,
            angle: 40,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 675.2122956061022, y: 181.03340757238308,
            angle: 53,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 296.90776337939946, y: 54.89309576837417,
            angle: 51,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 1077.5054352790721, y: 555.521158129176,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 276.25063618212425, y: 514.2850779510022,
            angle: 8,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 146.82023776899086, y: 250.5835189309577,
            angle: -5,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 45.19172897989012, y: 566.8886414253898,
            angle: -4,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 576.280924976184, y: 755.8953229398663,
            angle: 9,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 573.149499536729, y: 497.4699331848552,
            angle: 53,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 194.98972973678374, y: 371.8953229398664,
            angle: 50,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 30.79745266152501, y: 94.07572383073497,
            angle: 40,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 92.22979550822797, y: 689.173719376392,
            angle: 49,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 404.81246003471273, y: 573.5857461024499,
            angle: -44.99999999999966,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 508.30954338435845, y: 256.29398663697106,
            angle: -44.99999999999966,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cn2",
            x: 1066.7549491706795, y: 73.74832962138085,
            angle: 34.99999999999977,
            scaleX: 1,
            scaleY: 1
        }
    ]
}